import { useSnapshot } from 'valtio'
import cn from 'classnames'
import format from 'date-fns/format'
import React, { type ReactElement } from 'react'
import { recurringPaymentsProxy } from '../../../../recurringPaymentsProxy'

import {
  TableCell
} from '../../../../../../transactions/index/TransactionsTable/TransactionsRows/TableCell'
import { buildAppRecurringPaymentsPath } from '../../../../../../../../pages/app/recurring-charges/[id]'
import { PRETTY_RECURRING_PAYMENT_STATUS } from '../../../../../../../../shared/types/GlobalRecurringPaymentsStatus'
import RedTooltipIcon from '../../../../../../../../shared/components/ui/tooltips/recurringListIcon/RedTooltipIcon'
import { RecurringPaymentsAmountCell } from './components/AmountCell/RecurringPaymentsAmountCell'
import { determineStatusColorClass } from './components/AmountCell/utils'

function formatHyphenatedDates (dateString: string | null | undefined): string {
  if (!dateString) {
    return ''
  }
  const split = dateString.split('-')
  return format(new Date(`${split[1]}/${split[2]}/${split[0]}`), 'MMM d, y')
}

export function RecurringPaymentsRows (): ReactElement {
  const { recurringPayments } = useSnapshot(recurringPaymentsProxy)
  return (
    <>
      {recurringPayments.length === 0 && (
        <tr>
          <td colSpan={10}>
            <div className="text-center my-16 text-wpy-gray">
              No Results
            </div>
          </td>
        </tr>
      )}
      {recurringPayments.map((recurringPayment, i) => {
        const notLastRow = i !== (recurringPaymentsProxy.recurringPayments.length - 1)
        const path = buildAppRecurringPaymentsPath(recurringPayment.id)
        return (
          <tr
            key={recurringPayment.id}
            className={
              cn(
                'opacity-90 my-1 text-sm animate__animated animate__fadeIn',
                notLastRow && 'border-b border-gray-100'
              )
            }
          >
            <TableCell path={path}>  {recurringPayment.id}</TableCell>
            <TableCell path={path}>  {recurringPayment.customer?.companyName ?? 'No Company'}</TableCell>
            <TableCell path={path}>{`${recurringPayment.customer?.firstName ?? 'No First Name'} ${recurringPayment.customer?.lastName ?? 'No Last Name'}`}</TableCell>

            <TableCell path={path}> {recurringPayment.invoiceNumber}</TableCell>

            <TableCell path={path}>
              <div className={cn('border rounded-full flex items-center justify-center py-1 px-2', determineStatusColorClass(recurringPayment))}> {PRETTY_RECURRING_PAYMENT_STATUS[recurringPayment.status]}</div>
              <RedTooltipIcon tooltipText={recurringPayment.failedCount} />
            </TableCell>

            <TableCell path={path}>{recurringPayment.billingCycle}</TableCell>

            <RecurringPaymentsAmountCell recurringPayment={recurringPayment} />

            <TableCell path={path}> {recurringPayment.lastPaymentDate ? format(Date.parse(recurringPayment.lastPaymentDate), 'MMMM d, yyyy') : null}</TableCell>
            <TableCell path={path}> {formatHyphenatedDates(recurringPayment.nextPaymentDate)}</TableCell>
          </tr>
        )
      })}
    </>
  )
}
